<template>
    <div class="row button-question">
        <div class="col-xl-3 col-xxl-2 question-label">{{label}}</div>
        <div class="col-xl-7 col-xxl-8 question">
            <div class="row row-cols-3">
                <div class="col button-holder">
                    <button type="button" class="btn btn-outline-dark" @click="selectAllValue()">Select All</button>
                </div>
                <div class="col button-holder">
                    <button type="button" class="btn btn-outline-dark" @click="unselectAllValue()">Unselect</button>
                </div>
            </div>
            <div class="row row-cols-3">
                <template v-for="(val, index) in values" :key="index">
                  <div class="col button-holder">
                    <button type="button" class="btn" :class="{ 'btn-success': optionActive(val.value), 'btn-outline-dark': !optionActive(val.value)}" @click="setValue(val.value)" :disabled="!allowChange">{{val.label}}</button>
                  </div>
                  <div class="col button-holder" v-show="hideSection(index)"></div>
                </template>
            </div>
        </div>
        <div class="col-2 question-error">
          {{errors}}
        </div>
    </div>
</template>
<script>
import { mapState, mapGetters } from 'vuex'
import LabelFilledMixin from './LabelFilledPlaceholdersComputedMixin'

export default {
  name: 'AreaOfStudyOptionButtons',
  props: ['question', 'modelValue', 'errors', 'default', 'allowChange'],
  mixins: [LabelFilledMixin],
  emits: ['update:modelValue'],
  data () {
    return {
      values: []
    }
  },
  computed: {
    currentValue: {
      get () {
        return Array.isArray(this.modelValue) ? this.modelValue : []
      },
      set (newValue) {
        this.$emit('update:modelValue', newValue)
      }
    },
    placeholder () {
      return this.question.placeholder
    },
    maxSubjects () {
      return this.consumer?.max_area_of_study ?? -1
    },
    ...mapState({
      consumer: state => state.consumer.currentConsumer
    }),
    ...mapGetters({
      leadInfo: 'consumer/lead/leadInfo'
    })
  },
  methods: {
    setValue (val) {
      var curIndex = this.currentValue.indexOf(val)
      var updatedList = this.currentValue
      if (curIndex > -1) {
        updatedList.splice(curIndex, 1)
        this.currentValue = updatedList
      } else {
        if (this.maxSubjects < 0 || this.currentValue.length < this.maxSubjects) {
          updatedList.push(val)
          this.currentValue = updatedList
        }
      }
    },
    setValues (newValues) {
      this.values = this.default && this.question.dependsOn ? newValues.filter((v) => v.value !== this.default) : newValues
    },
    optionActive (val) {
      return this.currentValue.includes(val)
    },
    selectAllValue () {
      this.unselectAllValue()
      this.values.forEach((v) => {
        this.setValue(v.value)
      })
    },
    unselectAllValue () {
      this.currentValue.splice(0, this.currentValue.length)
    },
    hideSection (index) {
      return ((index + 1) % 2) === 0
    }
  },
  mounted () {
    this.setValues(this.question.values)
  },
  watch: {
    'question.values' (newList) {
      this.setValues(newList)
    }
  }
}
</script>

<style scoped>
.button-holder {
  margin-bottom: 10px;
}
.button-holder button {
  width: 100%;
  font-size: 12px;
  padding: 5px 10px;
}
</style>
